import styled from '@mui/material/styles/styled';
import Paper from '@mui/material/Paper';

export const Root = styled(Paper)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  border: '1px solid #d9edef',
  boxShadow: '0 1px 5px 0 rgb(127 127 227 / 10%)',
  borderRadius: '50px',
  padding: '8px 16px',
});